import script from "./CardEquipamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CardEquipamento.vue?vue&type=script&setup=true&lang=js"

import "./CardEquipamento.vue?vue&type=style&index=0&id=3dac0a84&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dac0a84"]])

export default __exports__